import {IComponentOptions, ILogService} from "angular";
import {StateService} from "@uirouter/angularjs";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {LoadingService} from "../../../shared/loading/loading.service";
import {Application} from "../../../shared/model/Application";
import {ApplicationService} from "../../../shared/application/application.service";

class DeleteDraftModalController {

    public modalInstance: IModalInstanceService;
    public resolve: any;
    public close: any;
    public dismiss: any;
    public draft: Application;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $state: StateService,
                private toaster: any,
                private loadingService: LoadingService,
                private applicationService: ApplicationService) {
    }

    public $onInit() {
        this.draft = this.resolve.draft;
    }

    public submit() {
        this.$log.info("submit()");
        this.loadingService.show();

        this.applicationService.deleteDraft(this.draft.id)
            .then((draft) => {
                this.$log.debug("deleteDraft:", draft);

                this.draft = draft;

                this.toaster.pop({type: "success", title: "Draft deleted"});
                this.close({$value: draft});
                this.$state.go("staff.dashboard", {}, {reload: true});

            })
            .finally(() => {
                    this.loadingService.hide();
                }
            );
    }

    public cancel() {
        this.dismiss({$value: "cancel"});
    }
}

export const DeleteDraftModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: DeleteDraftModalController,
    template: require("./draft-delete-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/application/draft-delete-modal/draft-delete-modal.component.ts